import * as React from "react";
import Button from "@mui/material/Button";
import LoadingButton from "./LoadingButton";
import {
  Divider,
  Drawer,
  IconButton,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Close } from "@mui/icons-material";

export interface DrawerProps {
  title: string;
  okText?: string;
  cancelText?: string;
  element: React.ReactNode;
  onCancel?: () => Promise<void>;
  noCancel?: boolean;
  onOk: () => Promise<unknown>;
  open: boolean;
  okDisabled?: boolean;
  noActions?: boolean;
  width?: number | string;
  minWidth?: number | string;
}

let resolve: (value?: unknown) => void, reject: (reason?: any) => void;

export default function CommonDrawer() {
  const [drawer, setDrawer] = React.useState<DrawerProps>({
    title: "",
    element: <span></span>,
    open: false,
    onOk: async () => {},
  });

  const onCancel = async () => {
    if (!drawer.onCancel) {
      setDrawer({ ...drawer, open: false });
      reject("canceled");
      return;
    }
    try {
      await drawer.onCancel();
      setDrawer({ ...drawer, open: false });
      reject("canceled");
    } catch (error) {
      console.error(error);
      reject(error);
      // todo display error message
    }
  };

  const onOk = async (e: React.MouseEvent<HTMLButtonElement>) => {
    try {
      var res = await drawer.onOk();
      setDrawer({ ...drawer, open: false });
      resolve(res);
    } catch (error) {
      console.error(error);
      reject(error);
      // todo display error message
    }
  };

  React.useEffect(() => {
    window.webApp = window.webApp || {};
    window.webApp.toggleDrawer = (param) => {
      setDrawer(param);
      return new Promise((rs, rj) => {
        resolve = rs as any;
        reject = rj as any;
      });
    };
  }, []);

  return (
    <Drawer
      onClose={onCancel}
      className="relative "
      anchor={"right"}
      open={drawer.open}
    >
      <Stack direction="column" justifyContent="space-between">
        <div
          className="padding-normal"
          style={{
            height: "calc(100vh - 62px)",
            overflowY: "auto",
            width: drawer.width || "90vw",
            minWidth: drawer.minWidth,
            maxWidth: drawer.width ? undefined : 320,
          }}
        >
          {drawer.element}
        </div>
        <div>
          <Divider />
          <Stack
            className="width-100p padding-normal"
            direction="row"
            justifyContent="space-between"
            spacing={3}
          >
            {!drawer.noCancel && (
              <Button sx={{ mr: 4 }} onClick={onCancel}>
                {drawer.cancelText || "Cancel"}
              </Button>
            )}
            <LoadingButton onClick={onOk}>
              {drawer.okText || "OK"}
            </LoadingButton>
          </Stack>
        </div>
      </Stack>
    </Drawer>
  );
}
